"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.2.4'] && _();
}
catch (e) { }
